import { notification } from 'antd';
import { UserFileDict } from '../../utils/settings';
import { GetMeAction, getProfilePicture } from '../Onboarding/auth/action';
import { fetchToken } from '../../firebase';
import { getSecondaryPermissionsAction } from '../../screen/auth/action';

export const onLoggedIn = async ({
  data,
  message,
  navigate = () => {},
  dispatch = () => {},
  toast = () => {},
}) => {
  if (data && data?.token) {
    localStorage.setItem('token', data.token);
    const { error: userError, data: loggedInUser } = await GetMeAction();
    const { data: secPermissionData } = await getSecondaryPermissionsAction();
    fetchToken();

    if (!userError && loggedInUser) {
      const url = getProfilePicture(loggedInUser?.profile_picture_details);

      if (typeof url !== 'object') {
        dispatch({
          type: 'SET_USER',
          data: { ...loggedInUser, profile_image: url },
        });
      } else dispatch({ type: 'SET_USER', data: loggedInUser });
      dispatch({
        type: 'SET_SECONDARY_PERMISSION',
        data: secPermissionData,
      });

      dispatch({
        type: 'SET_SECONDARY_PERMISSION_ROLES',
        data: secPermissionData.map((item) => item.role_name),
      });

      if (!loggedInUser.first_name) {
        return navigate('/CreatePassword', {
          state: {
            phone_number: loggedInUser.phone_no,
          },
        });
      }

      if (!loggedInUser.is_firm_onboarded) {
        return navigate('/FetchFirmDetail');
      }

      navigate('/');
    } else {
      return toast.error(message);
    }
  } else {
    return toast.error(message);
  }
};
